import React, { useEffect, useState, useCallback } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon";
import { Link } from "react-router-dom";

const GNBPURE03001S = () => {
    const { doAction, doActionFrm } = useApplicationCommon();
    const { addLinkService } = useApplicationCommon();
    const [news, setNews] = useState([]); // 소식 리스트
    const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태
    const [pagination, setPagination] = useState({ pageNo: 1, prevYn: "N", nextYn: "N", startPage: 1, endPage: 1 });
    const [activeButton, setActiveButton] = useState("전체"); // 버튼 클릭 이벤트 추가

    // ✅ 검색창 엔터 입력 시 실행
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            goSearch();
        }
    };

    // ✅ 소식 리스트 조회
    const goSearch = (pageNo = 1, button = activeButton) => {
        setActiveButton(button);

        const actionForm = {
            txGbnCd: "srchList",
            coNo: "1",
            newsCd: "",
            pageNo: pageNo,
        };

        // ✅ 호스트네임에 따라 값 변경
        const hostname = window.location.hostname;
        if (hostname.includes("gnbsoftec.co.kr")) actionForm.coNo = '1';
        else if (hostname.includes("puresolution.co.kr")) actionForm.coNo = '2';
        else actionForm.coNo = '1';

        if (button === "전체") actionForm.newsCd = '%';
        else if (button === "해외워크샵") actionForm.newsCd = '1';
        else if (button === "사우회활동") actionForm.newsCd = '2';
        else if (button === "사내활동") actionForm.newsCd = '3';

        doAction("COM0000SC", actionForm, (resData) => {
            if (resData.APP_HEADER.respCd === "N00001") {
                setNews(resData.LIST || []);
                setPagination({
                    pageNo: resData.pageNo,
                    prevYn: resData.prevYn,
                    nextYn: resData.nextYn,
                    startPage: resData.startPage,
                    endPage: resData.endPage,
                });
            }
        });
    };

    // ✅ 첫 번째 이미지 URL을 추출하는 함수
    const extractFirstImage = (htmlString) => {

        // ✅ HTML 엔티티 디코딩 (안 하면 태그가 정상적으로 변환되지 않음)
        const decodeEntities = (encodedString) => {
            const textarea = document.createElement("textarea");
            textarea.innerHTML = encodedString;
            return textarea.value;
        };

        // ✅ HTML 엔티티를 디코딩하여 실제 HTML 태그로 변환
        const decodedHtml = decodeEntities(htmlString);
        if (!decodedHtml) return ""; // 값이 없으면 빈 문자열 반환

        // HTML 문자열을 DOM 요소로 변환
        const div = document.createElement("div");
        div.innerHTML = decodedHtml;
        
        // 모든 <img> 태그 찾기
        const images = div.getElementsByTagName("img");

        // 첫 번째 이미지가 있다면 src 반환, 없으면 빈 값
        return images.length > 0 ? images[0].src : "../../asset/img/dolphin_cute.png";
    };

    const memoizedGoSearch = useCallback(goSearch, []);
    // ✅ 최초 조회
    useEffect(() => {
        goSearch(1, "전체");
    }, [memoizedGoSearch]);

    return (
        <CommonLayout>
            <CommonMenu />
            <div id="contents" className="container">
                <div className="sub-title bg-type04">
                    <h2>기업소개</h2>
                </div>
                <div className="location_wrap">
                    <ul className="depth1"  onClick={() => setIsDepthOpen(!isDepthOpen)}>
                        <li><Link to="/">home</Link></li>
                        <li><Link to="/" onClick={(e) => e.preventDefault()}>우리회사소식<span></span></Link>
                            <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                            <li><Link to="/GNBPURE00000S">CEO인사말</Link></li>
                            <li><Link to="/GNBPURE00001S">ABOUT US</Link></li>
                            <li><Link to="/GNBPURE03001S">우리회사소식</Link></li>
                            <li><Link to="/GNBPURE00002S">사업실적</Link></li>
                            <li><Link to="/GNBPURE00003S">오시는길</Link></li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div id="cont" className="cont">
                    <div className="inner">
                        <h3>우리회사소식</h3>
                        <div className="button-group">
                            <button className={`btn ${activeButton === "전체" ? "active" : ""}`} onClick={() => goSearch(1,  "전체")}>전체</button>
                            <button className={`btn ${activeButton === "해외워크샵" ? "active" : ""}`} onClick={() => goSearch(1, "해외워크샵")}>해외워크샵</button>
                            <button className={`btn ${activeButton === "사우회활동" ? "active" : ""}`} onClick={() => goSearch(1, "사우회활동")}>사우회활동</button>
                            <button className={`btn ${activeButton === "사내활동" ? "active" : ""}`} onClick={() => goSearch(1, "사내활동")}>사내활동</button>
                        </div>


                        <ul className="news-container" id="resultList">
                            {news.map((item, i) => {
                                // ✅ item.news_ttl에서 첫 번째 이미지 URL 가져오기
                                const firstImageUrl = extractFirstImage(item.news_cntn);

                                return (
                                    <li key={i}>
                                        <Link to={`/GNBPURE03002S?linkServiceCd=COM0000SC&txGbnCd=srchDetail&news_no=${item.news_no}`}>
                                            <div key={item.id} className="news-item">
                                                <img src={firstImageUrl || item.imageUrl} alt={item.title} className="news-image" />
                                                <div className="news-content">
                                                    <p className="news-date">{item.rg_dtm}</p>
                                                    <h2 className="news-title">{item.news_ttl}</h2>
                                                </div>
                                                <div className="news-source">{item.source}</div>
                                            </div>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>

                        {/* 페이지네이션 */}
                        <ul className="boardPage">
                        {pagination.prevYn === "Y" && (
                            <li>
                            <button onClick={() => goSearch(pagination.pageNo - 1)} title="이전페이지">
                                ⬅ 이전
                            </button>
                            </li>
                        )}

                        {Array.from({ length: pagination.endPage - pagination.startPage + 1 }, (_, i) => pagination.startPage + i).map((num) => (
                            <li key={num} className={pagination.pageNo === num ? "on" : ""}>
                            <button onClick={() => goSearch(num)}>{num}</button>
                            </li>
                        ))}

                        {pagination.nextYn === "Y" && (
                            <li>
                            <button onClick={() => goSearch(pagination.pageNo + 1)} title="다음페이지">
                                다음 ➡
                            </button>
                            </li>
                        )}
                        </ul>
                    </div>
                </div>
            </div>

        </CommonLayout>
    );
}

export default GNBPURE03001S;